<template>
<div v-loading="loading">
  <el-select
    filterable
    class="select-primary"
    size="large"
    placeholder="Selecione ..."
    v-model="eventIdSelected"
    name="eventIdSelected"
  >
    <el-option
      class="select-primary"
      value=""
      label=""
    ></el-option>
    <el-option
      v-for="item in events"
      filterable
      class="select-primary"
      :value="item._id"
      :label="`${item.reference} - ${item.city}`"
      :key="item._id"
    ></el-option>
  </el-select>


  <button
    @click="handleRemoverRanking ()"
    class="btn btn-warning btn-fill btn-wd"
  >
    Remover Ranking do Evento
  </button>


  <el-progress :percentage="progressPercentage"></el-progress>

</div>
</template>
<script>
import swal from 'sweetalert2'
import {mapGetters, mapActions} from 'vuex'

export default {
  data () {
    return {
      eventIdSelected: '',
      loading: false,
      progress: 0,
      total: 0
    }
  },
  computed: {
    ...mapGetters('events', {
      events: 'sortedByReference'
    }),
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      return parseInt((this.progress / this.total) * 100)
    }
  },
  methods: {
    ...mapActions('tickets', {fetchTickets: 'fetchAll', upsertTickets: 'updateMany', updateMany: 'updateMany'}),
    ...mapActions('events', {findEvent: 'fetchOne', upsertEvent: 'upsert'}),
    async handleRemoverRanking () {
      const valid = await this.checkValid()
      if (!valid) {
        return this.notifyFailure()
      } else {
        this.loading = true
        this.total = 0
        this.fetchTickets({where: {eventId: this.eventIdSelected}, limit: 9999999})
          .then(docs => this.removeRanking(docs))
          .catch(err => {
            console.log('failed fetch ticket', err)
          })
      }
    },

    async checkValid () {
      const event = await this.findEvent(this.eventIdSelected)
      console.log(event.hasSortTRG_889)
      return event.hasSortTRG_889 ? event.hasSortTRG_889 : false
    },

    removeRanking (docs) {
      docs = docs.map(item => {
        item.winner = false
        delete item.rankingNow
        delete item.rankingOriginal
        return item
      })
      this.total = (docs.length + 1)
      if (docs.length === 0) {
        this.notifyRankingRemoval(docs)
      } else {
        this.askConfirmation(docs)
          .then(async (valid) => {
            if (valid) {
              await this.removeWinners(docs)
            }
          })
      }
    },

    async removeWinners (docs) {
      const event = await this.findEvent(this.eventIdSelected)
      event.drawn = false
      docs.push(event)
      try {
        await this.updateMany(docs)
        this.notifyFinish()
      } catch (e) {
        console.log(e)
        this.notifyFailure(e)
      }
    },

    notifyRankingRemoval (docs) {
      this.loading = false

      return swal({
        title: `Existem ${docs.length} com ranking.`,
        text: `Todos os tickets estão sem ranking.`,
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    askConfirmation (docs) {
      return swal({
        title: `Existem ${docs.length} com ranking.`,
        html: `Você quer remover ranking de todos os tickets?`,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, faça isso!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    },

    notifyFinish () {
      this.loading = false
      swal({
        title: 'Sucesso',
        text: `Ação executada com sucesso.`,
        type: 'success',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
        .then(() => {
          this.notifyEventUpdated()
        })
    },

    notifyEventUpdated () {
      this.loading = false

      return swal({
        width: 1000,
        title: 'Foi removido ranking do evento.',
        type: 'success',
        confirmButtonClass: 'btn btn-success btn-fill',
        buttonsStyling: false
      })
    },

    notifyFailure (err) {
      this.loading = false

      return swal({
        width: 1000,
        title: 'Ocorreu um erro ao executar essa ação.',
        text: JSON.stringify(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/RemoveEventRanking.vue